import React from 'react'
import { motion } from 'framer-motion'

export default function LoadingScreen({ message = 'Iniciando sistema...', logoUrl = null }) {
    return (
        <div className="fixed inset-0 bg-background flex items-center justify-center z-50">
            <div className="flex flex-col items-center gap-6 p-8">
                {/* Logo Animation */}
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.5, ease: 'easeOut' }}
                    className="relative"
                >
                    <div className="w-24 h-24 bg-surface dark:bg-slate-900 rounded-2xl flex items-center justify-center shadow-lg mb-2 p-2 overflow-hidden ring-1 ring-border dark:ring-slate-800">
                        <img
                            src={logoUrl || '/logo.png'}
                            alt="Gallegos Asesores"
                            className="w-full h-full object-contain"
                        />
                    </div>
                    <motion.div
                        animate={{
                            rotate: 360,
                            scale: [1, 1.1, 1]
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            ease: 'easeInOut'
                        }}
                        className="absolute -bottom-2 -right-2 w-8 h-8 bg-blue-500 rounded-full border-4 border-background"
                    />
                </motion.div>

                {/* Text Animation */}
                <motion.div
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="flex flex-col items-center gap-2"
                >
                    <h2 className="text-xl font-bold text-text-primary dark:text-white">Gallegos Asesores</h2>
                    <p className="text-sm text-text-secondary dark:text-slate-400 font-medium animate-pulse">{message}</p>
                </motion.div>

                {/* Progress Bar */}
                <div className="w-48 h-1.5 bg-surface-highlight dark:bg-slate-800 rounded-full overflow-hidden mt-4">
                    <motion.div
                        initial={{ x: '-100%' }}
                        animate={{ x: '100%' }}
                        transition={{
                            repeat: Infinity,
                            duration: 1.5,
                            ease: 'linear'
                        }}
                        className="w-full h-full bg-blue-500 rounded-full"
                    />
                </div>
            </div>
        </div>
    )
}
